<div class="db-main__header">
    <div class="db-main__header-info">
        <div>
            <h2 class="mb16">
        <span class="db-main__website-name" [innerHTML]="website?.title | trim"
              [dsTooltipVisible]="(website?.title | trim)?.length >= 29"
              [dsTooltipPosition]="'bottom'"
              dsTooltipAlign="left"
              [dsTooltipColor]="'black'"
              [dsTooltipSize]="'small'"
              [dsTooltip]="website?.title | trim"
        ></span>
                <db-site-lock
                        [userSubscription]="userSubscription"
                        [passwordProtection]="passwordProtection"
                        [isWVCSite]="website?.isWVC"
                        [websiteId]="website?.id"
                        [websiteUrl]="website?.site_url"
                        [isStaging]="website?.type === 'staging'"
                        [demoUser]="demoUser"
                        [primaryChanged]="primaryChanged"
                        [user]="user">
                </db-site-lock>
            </h2>
            <a target="_blank" rel="noopener" class="db-main__site-url mt16" href="{{previewUrl}}">
                <span>{{ website?.site_url }}</span>
            </a>
        </div>

        <div class="db-main__admin">
            <div class="db-ai-vibe-wrap">
                <button class="ds-btn-outline ds-btn-icon db-ai-vibe animated"
                        [ngClass]="{'regenerate': !!website?.builderType}"
                        (click)="onVibeButtonClick()"
                        (mouseenter)="onMouseEnter()"
                        (mouseleave)="overlayVisible = false; showVibeGenerationTooltip = false"
                        [class.hovered]="!isMobile && overlayVisible">
                    <i class="db-icon db-icon-ds-ai-border mr8"></i>
                    <span class="initial-text">AI</span>
                    <span class="hovered-text">{{!!website?.builderType ? ('text_regenerateWebsiteWithAi' | dbText) : ('text_generateWebsiteWithAI' | dbText)}}</span>
                </button>
                <ng-container [ngTemplateOutlet]="generateTooltip"></ng-container>
            </div>
            <ng-container  *ngIf="!website?.isNetwork || (website?.isNetwork && website?.parentId)">
                <!-- WVC website - use click handler -->
                <a class="edit-btn"
                   *ngIf="website?.connectedFrom !== 'speed_optimizer' && !!website?.isWVC"
                   (click)="handleWvcEditClick($event)">
                    {{!!isMobile ? ('text_edit_website' | dbText) : ('text_editYourWebsite' | dbText)}}
                </a>
                <!-- Non-WVC website - with dbWpLink -->
                <a class="edit-btn"
                   *ngIf="website?.connectedFrom !== 'speed_optimizer' && !website?.isWVC"
                   dbWpLink [adminLink]="redirectUrl" [websiteId]="website?.id"
                   target="_blank" rel="noopener">
                    {{!!isMobile ? ('text_edit_website' | dbText) : ('text_editYourWebsite' | dbText)}}
                </a>
                <!-- Speed optimizer website - direct href -->
                <a class="edit-btn"
                   *ngIf="website?.connectedFrom === 'speed_optimizer'"
                   [href]="website?.adminUrl" target="_blank" rel="noopener">
                    {{!!isMobile ? ('text_edit_website' | dbText) : ('text_editYourWebsite' | dbText)}}
                </a>
            </ng-container>


            <span class="divider" *ngIf="!website?.isNetwork || (website?.isNetwork && website?.parentId)"></span>
            <button class="ds-btn-outline wp-admin m" [dsTooltip]="wpAdminTemplate"
                    (click)="openAdmin()"
                    [dsTooltipMode]="'hoverStatic'"
                    [dsTooltipHoveredElement]="'.db-main__icons'"
                    dsTooltipPosition="bottom" [dsTooltipSize]="'large'"
                    dsTooltipAlign="right" dsTooltipFont="regular">
                <i class="db-icon db-icon-ds-wp-border"></i>
            </button>
            <div *ngIf="canClone || !hideRemoveBtn
                || (!(website?.isNetwork || (website?.isNetwork && !!website?.parentId)) && userSubscription?.plan?.services?.ai_builder && !!website?.domain_hash)"
                 class="ds-btn-outline ds-btn-icon actions"
                 [dsTooltip]="actionsList"
                 [dsTooltipMode]="'hoverStatic'"
                 [dsTooltipHoveredElement]="'.actions-dropdown'"
                 [dsTooltipLeftPxs]="-4"
                 dsTooltipPosition="bottom" [dsTooltipSize]="'large'"
                 dsTooltipAlign="right" dsTooltipFont="regular"
                 [ngClass]="{'hovered': !!toggled}"
                 #actionsTooltip>
                <i class="db-icon db-icon-ds-more-horizontal" [ngClass]="{'toggled': toggled}"></i>
            </div>

            <ng-container [ngTemplateOutlet]="clearAllCaches"></ng-container>
        </div>
        @if (+userSubscription?.product_id === +Config.vibeCodingPluginId && userSubscription?.plan?.vibeService) {
          <div class="db-vibe-overlay" [class.visible]="overlayVisible"></div>
        }
    </div>

  <div class="info-block">
    <div class="info-item short" *ngIf="!!userSubscription?.multipleBuilder && !!website?.builderType">
      <div class="label">{{ 'text_builtWith' | dbText }}</div>
      <div class="value">{{website?.builderType === 'wvc' ? 'AI Vibe Builder' : 'AI Classic Builder'}}</div>
    </div>
    <div class="info-item big" *ngIf="!!website?.domain_hash">
      <div class="label">{{ 'text_hostedOn' | dbText }}</div>
      <div class="value">{{ 'text_premiumHosting' | dbText }}</div>
    </div>
    <div class="info-item big" *ngIf="hostingInfoData?.hostingBasicInfo?.location">
      <div class="label">{{ 'text_dataCenter' | dbText }}</div>
      <div class="value">{{hostingInfoData?.hostingBasicInfo?.location}}</div>
    </div>
    <div class="info-item medium" *ngIf="hostingInfoData?.hostingBasicInfo?.ip">
      <div class="label">IPv4 address</div>
      <div class="value">{{hostingInfoData?.hostingBasicInfo?.ip}}</div>
    </div>
        @if (!website?.isNetwork || (website?.isNetwork
            && website?.multisiteType === 'subdomain' && website?.parentId) || (website?.isNetwork
            && website?.multisiteType === 'subfolder' && !website?.parentId)) {
            <div class="info-item small">
                <div class="label">SSL</div>
                <div class="value">
                    <i class="db-icon db-icon-{{(addAllDomains?.length || !addAllDomains) || removeAllDomains?.length || hasSslCertificate ? 'ds-checkmark-circle green' : 'ds-minus-bg orange'}}"></i>
                    <p [innerHTML]="(addAllDomains?.length || !addAllDomains) || removeAllDomains?.length || !!hasSslCertificate ? 'Active SSL' : 'Inactive SSL'"></p>
                </div>
            </div>
        }

    </div>
</div>

<ng-template #clearAllCaches>
    <div class="main-page-header__clear-caches" [class.active]="showClearCache">
        <h1>{{'text_clearAllCaches' | dbText}}</h1>
        <div class="mt2">
            <p>{{'text_clearAllCachesDesc' | dbText}}</p>
            <a [ngClass]="{'ds-btn-disabled': clearCacheLoading || clearCacheFinished}"
               (click)="clearCache()">
                <span [class.hidden]="clearCacheLoading || clearCacheFinished">{{'text_clearCacheButton' | dbText}}</span>
                @if (clearCacheLoading && !clearCacheFinished) {
                    <db-loading-dotted-circle
                            [percent]="clearCachePercent" [whiteColored]="true"
                    ></db-loading-dotted-circle>
                }
                @if (!!clearCacheFinished) {
                    <i class="db-icon db-icon-ds-checkmark"></i>
                }
            </a>
        </div>
    </div>
</ng-template>

<ng-template #actionsList>
    <div class="db-main-header__websites-actions-list"
         [ngClass]="{'disable': !!disableCopyWebsite || !!disableControls}">
        <div class="action-name website-action cache" [class.active]="showClearCache" (click)="clearCachesClick()">
            <div><i class="db-icon db-icon-ds-clear-broom"></i><span>{{'text_clearAllCaches' | dbText}}</span></div>
            <i class="db-icon db-icon-ds-single-arrow"></i>
        </div>
        @if (canClone) {
            <p class="action-name website-action" (click)="cloneWebsite()">
                <i class="db-icon db-icon-ds-dublicate"></i><span>{{'text_duplicateWebsite' | dbText}}</span>
            </p>
        }

        @if (!hideRemoveBtn) {
            <p class="action-name website-action" (click)="removeWebsite()">
                <i class="db-icon db-icon-ds-trash"></i><span>{{'text_removeWebsite' | dbText}}</span>
            </p>
        }

    </div>
</ng-template>

<ng-template #wpAdminTemplate>
    <div class="main-header__wp-admin" [ngClass]="{'multisite': !!website?.isNetwork && !website?.parentId}">
        <div class="main-header__wp-admin-item"
             (click)="openAdmin()">
            <div>
                <strong>{{'text_accessWordPressDashboard' | dbText}}</strong>
                <p class="mt2">{{'text_manageContentFromWP' | dbText}}</p>
            </div>
            <a class="db-website-item-menu__action-button sl-website-item-menu_back_url">
                <i class="db-icon db-icon-ds-external-n external-link"></i>
            </a>
        </div>
        <div class="main-header__wp-admin-item update-version">
            <div>
                <strong>{{'text_wordPressCurrentVersion' | dbText: {version: website?.platformVersion} }}</strong>
                @if (!hasUpdate) {
                    <p class="mt2">{{'text_latestWPVersion' | dbText}}</p>
                } @else {
                    <p class="mt2">{{ 'text_newVersionWP' | dbText}}</p>
                }
            </div>
            @if (hasUpdate) {
                <a class="update-btn" (click)="update()">
                    @if (!!updatingWPVersion) {
                        <db-loading-dotted-circle
                                [percent]="updatingWPVersionPercent"></db-loading-dotted-circle>
                    } @else {
                        <span [innerHTML]="'text_updateVersion' | dbText:{version: wpNewVersion}"></span>
                    }

                </a>
            }
        </div>
    </div>
</ng-template>

<ng-template #generateTooltip>
  <div class="main-page-header__vibe-tooltip-wrap" [class.open]="showVibeGenerationTooltip" [class.close]="!showVibeGenerationTooltip"
       (mouseenter)="overlayVisible = true; showVibeGenerationTooltip = true"
       (mouseleave)="overlayVisible = false; showVibeGenerationTooltip = false">
      @if (!!website?.builderType || (!website?.builderType && !userSubscription?.multipleBuilder)
      || (website.isNetwork && !!website.parentId)) {
          <div class="main-page-header__vibe-tooltip">
              <div>
                  <p>
                      @if (!!website?.builderType) {
                          {{ 'text_regenerateExistingWebsite' | dbText }}
                      } @else {
                          {{ 'text_createBrandNewWebsite' | dbText }}
                      }
                  </p>
                  @if (!!website?.builderType) {
                      @if (website?.builderType === 'wvc') {
                          <span [innerHTML]="'text_aiSiteGenerationsOf' | dbText:{out: vibeLimitations?.create_limitations?.already_used, to: vibeLimitations?.create_limitations?.limitation +
                              (vibeLimitations?.additional_credits?.total_credits || 0)}"></span>
                      } @else {
                          <span [innerHTML]="'text_aiSiteGenerationsOf' | dbText:{out: generatedWebsitesCount, to: totalGeneratedWebsitesCount}"></span>
                      }
                  }
                  @else {
                      @if (userSubscription?.availableBuilder === 'wvc') {
                          <span [innerHTML]="'text_aiSiteGenerationsOf' | dbText:{out: vibeLimitations?.create_limitations?.already_used, to: vibeLimitations?.create_limitations?.limitation +
                              (vibeLimitations?.additional_credits?.total_credits || 0)}"></span>
                      } @else {
                          <span [innerHTML]="'text_aiSiteGenerationsOf' | dbText:{out: generatedWebsitesCount, to: totalGeneratedWebsitesCount}"></span>
                      }
                  }
              </div>
          </div>

      }


    <div class="db-website-prompt__tooltip-content db-website-prompt__tooltip-content--model" *ngIf="!website?.builderType && userSubscription?.multipleBuilder && !website.isNetwork">
      <div class="db-website-prompt__tooltip-option" (click)="openGenerationDialog('wvc'); closeTooltip()">
        <div class="db-website-prompt__model-option">
          <div>
            <div class="db-website-prompt__model-option-icon">
              <i class="db-icon db-icon-ds-ai"></i>
            </div>
            <div>
              <span class="db-website-prompt__model-name">AI Vibe Builder</span>
              <span class="db-website-prompt__model-desc">React + WordPress</span>
            </div>
          </div>
        </div>
      </div>
      <div class="db-website-prompt__tooltip-option mt1" (click)="openGenerationDialog('section_based'); closeTooltip()">
        <div class="db-website-prompt__model-option">
          <div>
            <div class="db-website-prompt__model-option-icon">
              <i class="db-icon db-icon-ds-sidebar-builder"></i>
            </div>
            <div>
              <span class="db-website-prompt__model-name">AI Classic Builder</span>
              <span class="db-website-prompt__model-desc">{{ 'text_proFeaturesOnElementor' | dbText }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</ng-template>
